import { render, staticRenderFns } from "./OrganizationSetting.vue?vue&type=template&id=dbce0308&scoped=true&"
import script from "./OrganizationSetting.vue?vue&type=script&lang=ts&"
export * from "./OrganizationSetting.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationSetting.vue?vue&type=style&index=0&id=dbce0308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbce0308",
  null
  
)

export default component.exports